import { fillerColDef } from "@/lib/fillerColDef";
import { ColDef } from "ag-grid-community";
import { clearAllFiltersContextMenuObject } from "../../tradeActionSummary/contextMenusRightClick/genericContextMenuItems";
import { defaultColumnWidths } from "@/lib/interfaces and Enums/ENUMColumnWidths";
import { TableHeaderField } from "@/lib/interfaces and Enums/ENUMTableHeaders";
import NominalCellEditor from "./cellEditors/NominalCellEditor";
import RateCellEditor from "./cellEditors/RateCellEditor";
import { returnStringFormattedDateTime } from "@/lib/globalFormatterHelper";


export function returnAxeCreationColDefs(
  theme: any,
) {
  const axeCreationColDefs: ColDef[] = [
    // {
    //   checkboxSelection: (params) => {
    //     if (params.data.securityId && params.data.isin) return true;
    //     return false;
    //   },
    //   editable: false,
    //   enableRowGroup: false,
    //   enableCellChangeFlash: false,
    //   width: defaultColumnWidths.checkbox + defaultColumnWidths.expandArrow,
    //   sortable: false,
    //   filter: false,
    //   resizable: false,
    //   suppressMovable: true,
    //   lockPosition: "left", // This ensures the column stays in the first position
    //   suppressColumnsToolPanel: true,
    //   headerCheckboxSelectionFilteredOnly: true,
    //   // headerCheckboxSelection: true,
    //   mainMenuItems: ["resetColumns"],
    // },
    {
      field: "axeSubstring",
      headerName: TableHeaderField.axeSubstring,
      headerClass: "AxeCreationAxeSubstring",
      colId: "AxeCreationAxeSubstring",
      width: defaultColumnWidths.name,
      filter: "agTextColumnFilter",
    },
    {
      field: "maturity",
      headerName: TableHeaderField.maturityDate,
      headerClass: "AxeCreationMaturityDate",
      colId: "AxeCreationMaturityDate",
      cellDataType: "dateString",
      width: defaultColumnWidths.date,
      filter: "agDateColumnFilter",
    },
    {
      field: "providedDate",
      headerName: TableHeaderField.providedDate,
      headerClass: "AxeCreationProvidedDate",
      colId: "AxeCreationProvidedDate",
      width: defaultColumnWidths.date,
      filter: "agTextColumnFilter",
    },
    {
      field: "direction",
      headerName: TableHeaderField.direction,
      headerClass: "AxeCreationDirection",
      colId: "AxeCreationDirection",
      cellDataType: "string",
      width: defaultColumnWidths.side,
      cellRendererParams: { theme },
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["Buy", "Sell"],
      },
    },
    {
      field: "nominal",
      headerName: TableHeaderField.nominal,
      headerClass: "AxeCreationNominal",
      colId: "AxeCreationNominal",
      cellDataType: "number",
      width: defaultColumnWidths.nominal,
      cellEditor: NominalCellEditor,
      filter: "agNumberColumnFilter",
    },
    {
      field: "rate",
      headerName: TableHeaderField.rate,
      headerClass: "AxeCreationRate",
      colId: "AxeCreationRate",
      cellDataType: "number",
      cellEditor: RateCellEditor,
      filter: "agNumberColumnFilter",
      width: defaultColumnWidths.referenceRate,
      valueFormatter: (params) => {
        if (!params.data || params.data.rate == null) {
          return "";
        }
        const percentRate = params.data.rate * 100;
        return percentRate.toString() + "%";
      },
    },
    {
      field: "isin",
      headerName: TableHeaderField.isin,
      headerClass: "AxeCreationIsin",
      colId: "AxeCreationIsin",
      cellDataType: "string", // todo make a custom cell editor to handle isin input requirements (see task 13267 comments)
      width: defaultColumnWidths.isin,
      filter: "agTextColumnFilter",
    },
    {
      field: "issuerCountry",
      headerName: TableHeaderField.issuerCountry,
      headerClass: "AxeCreationIssuerCountry",
      colId: "AxeCreationIssuerCountry",
      editable: false,
      filter: "agTextColumnFilter",
      width: defaultColumnWidths.country,
    },
    {
      field: "issuer",
      headerName: TableHeaderField.issuer,
      headerClass: "AxeCreationIssuer",
      colId: "AxeCreationIssuer",
      editable: false,
      filter: "agTextColumnFilter",
      width: defaultColumnWidths.issuer,
    },
    {
      field: "dateCreated",
      headerName: TableHeaderField.dateCreated,
      headerClass: "AxeCreationDateCreated",
      colId: "AxeCreationDateCreated",
      editable: false,
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["reset"],
        comparator: (filterLocalDateAtMidnight: Date, cellValue: Date) => {
          if (!cellValue) return -1;

          const cellDate = new Date(cellValue);
          const cellYear = cellDate.getFullYear();
          const cellMonth = cellDate.getMonth(); // 0-based
          const cellDay = cellDate.getDate();

          const filterYear = filterLocalDateAtMidnight.getFullYear();
          const filterMonth = filterLocalDateAtMidnight.getMonth();
          const filterDay = filterLocalDateAtMidnight.getDate();

          if (cellYear < filterYear) return -1;
          if (cellYear > filterYear) return 1;

          if (cellMonth < filterMonth) return -1;
          if (cellMonth > filterMonth) return 1;

          if (cellDay < filterDay) return -1;
          if (cellDay > filterDay) return 1;
          return 0; // Exact match - T
        },
      },
      valueFormatter: (params) => {
        if (params.value) {
          return returnStringFormattedDateTime(params.value);
        } else return "";
      },
      width: defaultColumnWidths.actionedInfo,
      sort: "desc",
    },

    ...fillerColDef,
  ];
  return axeCreationColDefs;
}

export const defaultColDefAxeCreation = {
  editable: false, //temporary
  // editable: (params: EditableCallbackParams) => {
  //   if (!params.data.securityId) return true;
  //   return false;
  // },
  // cellClass: (params: CellClassParams) => {
  //   return !params.data.securityId
  //     ? theme == "light"
  //       ? "inputCellOtherLight roundedInputCell"
  //       : "inputCellOtherDark roundedInputCell"
  //     : "";
  // },

  suppressHeaderMenuButton: true,

  filter: true,
  cellStyle: { borderRight: "Var(--ag-grid-cubeCustom-cell-border)" },
  enableRowGroup: true,
  filterParams: {
    applyMiniFilterWhileTyping: true,
    buttons: ["reset"],
  },
  mainMenuItems: [
    "sortAscending",
    "sortDescending",
    "sortUnSort",
    "separator",
    "pinSubMenu",
    "separator",
    "autoSizeThis",
    "separator",
    "rowGroup",
    "separator",
    "resetColumns",
    { ...clearAllFiltersContextMenuObject },
  ],
};

// export const defaultColDefAxeCreation = (theme: string | undefined) => {
//   return {
//     editable: false, //temporary
//     // editable: (params: EditableCallbackParams) => {
//     //   if (!params.data.securityId) return true;
//     //   return false;
//     // },
//     // cellClass: (params: CellClassParams) => {
//     //   return !params.data.securityId
//     //     ? theme == "light"
//     //       ? "inputCellOtherLight roundedInputCell"
//     //       : "inputCellOtherDark roundedInputCell"
//     //     : "";
//     // },
//     suppressHeaderMenuButton: true,

//     filter: true,
//     cellStyle: { borderRight: "Var(--ag-grid-cubeCustom-cell-border)" },
//     enableRowGroup: true,
//     filterParams: {
//       applyMiniFilterWhileTyping: true,
//       buttons: ["reset"],
//     },

//     mainMenuItems: [
//       "sortAscending",
//       "sortDescending",
//       "sortUnSort",
//       "separator",
//       "pinSubMenu",
//       "separator",
//       "autoSizeThis",
//       "separator",
//       "rowGroup",
//       "separator",
//       "resetColumns",
//       { ...clearAllFiltersContextMenuObject },
//     ],
//   };
// };
